var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_13279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8289 39.0215V51.0991L73.5311 50.7293C72.4576 49.4703 71.384 48.2113 70.3174 46.9524C68.1288 44.3846 65.9402 41.8169 63.7585 39.242L63.5853 39.0073H63.239C62.678 39.0144 62.117 39.0144 61.556 39.0073H61.3067L61.182 39.2349C60.3024 40.8993 59.409 42.5566 58.5294 44.221L58.3631 44.5909V44.975C58.3631 50.0962 58.3631 55.2175 58.3562 60.3458V61.0073L58.9795 61.0002C60.6002 60.9931 62.214 61.0002 63.8347 61.0002H64.5758V60.5023C64.5758 56.9103 64.5758 53.3539 64.5758 49.7904V49.4774L64.8874 49.8188C68.0249 53.3397 71.1693 56.8605 74.2999 60.3885L74.847 60.986L75.4911 61.0002C76.8902 61.0002 78.2893 61.0002 79.6952 61.0002C79.7991 61.0002 79.903 60.986 80.0138 60.986V39.0215H73.8428H73.8289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1076 55.5587C32.0373 51.9738 34.974 48.3961 37.9106 44.8183L38.1807 44.4698L37.9175 43.979C37.1349 42.4711 36.3592 40.9631 35.5904 39.4481L35.3549 39.0071H34.7454C30.0426 39.0071 25.3399 39 20.6302 39H20.2978V44.1355H30.7768C30.6798 44.2635 30.6244 44.3346 30.569 44.3986C27.1614 48.4387 23.7538 52.4717 20.3462 56.5047L20.0138 56.8959V57.4009C19.9999 58.4892 20.0069 59.5774 20.0069 60.6657C20.0069 60.7582 20.0138 60.8577 20.0207 60.9644H38.8872V55.8503H28.9068C28.9968 55.7152 29.0522 55.6369 29.1076 55.5658V55.5587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7068 39H59.3743C57.4489 39 55.5235 39 53.605 39H53.0163L52.7462 39.5477C51.3402 42.4213 49.9342 45.2877 48.5213 48.1542C48.4797 48.2467 48.4243 48.332 48.3551 48.4601C46.769 45.2806 45.2037 42.151 43.6454 39.0285H36.9341C36.9895 39.1494 37.038 39.2489 37.0865 39.3414C39.5798 44.1995 42.0663 49.0504 44.5527 53.9085L44.8505 54.4989V55.3809C44.8574 57.0524 44.8574 58.7239 44.8505 60.4025V61H45.3838C47.2954 60.9858 49.2139 61 51.1255 61C51.2224 61 51.3125 61.0071 51.4441 61V60.6159C51.4441 58.731 51.4441 56.8461 51.4441 54.9541V54.4846L51.6034 54.2144C54.076 49.5697 56.5555 44.925 59.035 40.2874C59.2497 39.882 59.4644 39.4766 59.7068 39.0285V39Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_13279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 22,
    fill: "white",
    transform: "translate(20 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZyn);
export default __webpack_public_path__ + "static/media/zyn.dd699ac24d5223558d81e86623325b99.svg";
export { ForwardRef as ReactComponent };